import { AccordionSectionLectureComponent, ComponentType, RichTextType } from 'redux/schemas/models/lecture-component';

export enum EditableCourseElements {
  SECTION = 'LectureSection',
  SUBSECTION = 'LectureSubsection',
  LESSON = 'LecturePage',
}

export type EditableLectureComponent =
  ComponentType.TEXT_WITH_IMAGE_BKG
  | ComponentType.TEXT_WITH_IMAGE_SIDE
  | ComponentType.TEXT_WITH_IMAGE_TOP
  | ComponentType.RICH_TEXT
  | ComponentType.STYLED_LINK
  | ComponentType.HEADER_STYLE1
  | ComponentType.HEADER_STYLE2
  | ComponentType.HEADER_STYLE3
  | ComponentType.ACCORDION
  | ComponentType.PROFILE_COMPLETION
  | ComponentType.PUBLIC_PEER_EVALUATION
  | ComponentType.PRIVATE_PEER_EVALUATION
  | ComponentType.TEAM_DISCUSSION
  | ComponentType.TOPIC
  | ComponentType.EXERCISE
  | ComponentType.POLL
  | ComponentType.EXTERNAL_TOOL
  | ComponentType.SURVEY
  | ComponentType.QUIZ
  | ComponentType.PROGRESSIVE_QUIZ
  | ComponentType.AUDIO
  | ComponentType.VIDEO;

export type EditableTrueType =
  | RichTextType.FULL
  | RichTextType.SIMPLE;

export type EditableElements = EditableCourseElements | EditableLectureComponent;

export type EditableActivity = {
  title: string,
  description?: string,
};

export interface TranslationInfo {
  type: EditableElements,
  // The content could be a string or an array of elements such as AccordionSections
  content: string | AccordionSectionLectureComponent[] | EditableActivity,
  id: number,
  // In case the lecture component has a subtype such as RichTextType.FULL (HTML)
  trueType?: EditableTrueType,
  // In case the lecture component requires viewOptions
  viewOptions?: {
    backgroundColor?: string;
    textColor?: string;
    textStyle?: string;
    verticalAlign?: string;
    textAlign?: string;
  },
  // In case it's a course element
  lectureSectionId?: number,
  lectureSubsectionId?: number,
}
